import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGaurdService } from './authenticate/auth-gaurd.service';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './tabs/dashboard/dashboard.component';
// import { RegisterComponent } from './register/register.component';
import { PendingrequestComponent } from './tabs/pending/pendingrequest/pendingrequest.component';
import { PendingViewMobileComponent } from './tabs/pending/pending-view-mobile/pending-view-mobile.component';
import { ApprovedHcComponent } from './tabs/approved/approved-hc/approved-hc.component';
import { ApprovedViewMobileComponent } from './tabs/approved/approved-view-mobile/approved-view-mobile.component';
import { StaredHcComponent } from './tabs/stared/stared-hc/stared-hc.component';
import { StaredViewMobileComponent } from './tabs/stared/stared-view-mobile/stared-view-mobile.component';
import { ShowhiddenHcComponent } from './tabs/showhidden/showhidden-hc/showhidden-hc.component';
import { ShowhiddenViewMobileComponent } from './tabs/showhidden/showhidden-view-mobile/showhidden-view-mobile.component';
import { TrashHcComponent } from './tabs/trash/trash-hc/trash-hc.component';
import { TrashViewMobileComponent } from './tabs/trash/trash-view-mobile/trash-view-mobile.component';
import { SpecificationComponent } from './tabs/specification/specification/specification.component';
import { SpecificationViewMobileComponent } from './tabs/specification/specification-view-mobile/specification-view-mobile.component';
import { SpecificationHcComponent } from './tabs/specification/specification-hc/specification-hc.component';
import { RemarkComponent } from './tabs/remark/remark/remark.component';
import { RemarkHcComponent } from './tabs/remark/remark-hc/remark-hc.component';
import { RemarkViewMobileComponent } from './tabs/remark/remark-view-mobile/remark-view-mobile.component';
import { SubjectComponent } from './tabs/subject/subject/subject.component';
import { SubjectHcComponent } from './tabs/subject/subject-hc/subject-hc.component';
import { SubjectViewMobileComponent } from './tabs/subject/subject-view-mobile/subject-view-mobile.component';
import { UpdateHcComponent } from './tabs/update-hc/update-hc.component';
import { VitalComponent } from './tabs/vital/vital/vital.component';
import { GetotpallapprovedComponent } from './tabs/allapproved/getotpallapproved/getotpallapproved.component';
import { VitalchartComponent } from './tabs/vital/vitalchart/vitalchart.component';
// import{RegistrationFormComponent} from './registration-form/registration-form.component';
import { BlankpageComponent } from './blankpage/blankpage.component';
import { PaymentsuccessComponent } from './paymentsuccess/paymentsuccess.component';
import { PaymentfailureComponent } from './paymentfailure/paymentfailure.component';
import { AddTransctionPasswordComponent } from './add-transction-password/add-transction-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ProfileComponent } from './profile/profile.component';
import{UpdateprofileComponent} from './updateprofile/updateprofile.component';
import { SharehealthcardComponent } from './sharehealthcard/sharehealthcard.component';
import { DoctordashbordComponent } from './doctordashbord/doctordashbord/doctordashbord.component';
import { DoctorpageComponent } from './doctordashbord/doctorpage/doctorpage.component';
import { SendemailComponent } from './tabs/sendemail/sendemail/sendemail.component';
import { SendemailViewMobileComponent } from './tabs/sendemail/sendemail-view-mobile/sendemail-view-mobile.component';
import { AllapprovedViewMobileComponent } from './tabs/allapproved/allapproved-view-mobile/allapproved-view-mobile.component';
import { CampregistrationComponent } from './doctordashbord/campregistration/campregistration.component';
import { HealthCardBackSideComponent } from './doctordashbord/health-card-back-side/health-card-back-side.component';
import { UpdateCampRegisterUserComponent } from './doctordashbord/update-camp-register-user/update-camp-register-user.component';
import { MultiUserRegistrationComponent } from './doctordashbord/multi-user-registration/multi-user-registration.component';
import { BuyNowButtonClickComponent } from './buy-now-button-click/buy-now-button-click.component';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },

  // { path: 'register', redirectTo: 'register', pathMatch: 'full' }, 
  
  { path: 'buynow', component:BuyNowButtonClickComponent },
  
  
  // {path:'register',component:RegisterComponent,canActivate:[AuthGaurdService]},
  {
    path: 'dashboard', component: DashboardComponent,canActivate:[AuthGaurdService],
    children: [
      {path:'',redirectTo:'pendingrequest',pathMatch:'full',canActivate:[AuthGaurdService]},//set dashboard as pending request
      //  {path:'',redirectTo:'subject',pathMatch:'full',canActivate:[AuthGaurdService]},//set dashboard as subject
      
      {path:'pendingrequest',component:PendingrequestComponent,canActivate:[AuthGaurdService]},
      {path:'viewpending/:id',component:PendingViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'approvedhc',component:ApprovedHcComponent,canActivate:[AuthGaurdService]},
      {path:'viewapproved/:id',component:ApprovedViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'staredhc',component:StaredHcComponent,canActivate:[AuthGaurdService]},
      {path:'viewstared/:id',component:StaredViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'showhidden',component:ShowhiddenHcComponent,canActivate:[AuthGaurdService]},
      {path:'viewhidden/:id',component:ShowhiddenViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'trashhc',component:TrashHcComponent,canActivate:[AuthGaurdService]},
      {path:'viewtrash/:id',component:TrashViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'specification',component:SpecificationComponent,canActivate:[AuthGaurdService]},
      {path:'specificationhc/:id',component:SpecificationHcComponent,canActivate:[AuthGaurdService]},
      {path:'viewspec/:mailId/:specId',component:SpecificationViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'remark',component:RemarkComponent,canActivate:[AuthGaurdService]},
      {path:'remarkhc/:id',component:RemarkHcComponent,canActivate:[AuthGaurdService]},
      {path:'viewremark/:mailId/:remarkId',component:RemarkViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'subject',component:SubjectComponent,canActivate:[AuthGaurdService]},
      {path:'subjecthc/:id',component:SubjectHcComponent,canActivate:[AuthGaurdService]},
      {path:'viewsubject/:mailId/:subjectId',component:SubjectViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'updatehc/:id/:compname',component:UpdateHcComponent,canActivate:[AuthGaurdService]},
      {path:'vital',component:VitalComponent,canActivate:[AuthGaurdService]},
      {path:'vitalchart',component:VitalchartComponent,canActivate:[AuthGaurdService]},
      {path:'getotpallapproved',component:GetotpallapprovedComponent,canActivate:[AuthGaurdService]},
      {path:'viewallapproved',component:AllapprovedViewMobileComponent,canActivate:[AuthGaurdService]},
      {path:'blankpage',component:BlankpageComponent,canActivate:[AuthGaurdService]},
      {path:'paymentsuccess',component:PaymentsuccessComponent,canActivate:[AuthGaurdService]},
      {path:'paymentfailure',component:PaymentfailureComponent,canActivate:[AuthGaurdService]},
      {path:'transctionPassword',component:AddTransctionPasswordComponent,canActivate:[AuthGaurdService]},
      {path:'changePassword',component:ChangePasswordComponent,canActivate:[AuthGaurdService]},
      {path:'profile',component:ProfileComponent,canActivate:[AuthGaurdService]},
      {path:'updateprofile/:id',component:UpdateprofileComponent,canActivate:[AuthGaurdService]},
      {path:'sharehealthcard',component:SharehealthcardComponent,canActivate:[AuthGaurdService]},
      {path:'sentemail',component:SendemailComponent,canActivate:[AuthGaurdService]},
      {path:'viewsentemail/:id',component:SendemailViewMobileComponent,canActivate:[AuthGaurdService]},
    ]},
{
  path: 'doctordashboard', component:DoctordashbordComponent,
  children: [
    {path:'',redirectTo:'doctorpage',pathMatch:'full'},
    {path:'doctorpage',component:DoctorpageComponent,canActivate:[AuthGaurdService]},
    {path:'campregistration',component:CampregistrationComponent},
    {path:'healthcardbackside',component:HealthCardBackSideComponent},
    {path:'updatecampregisteruser/:id',component:UpdateCampRegisterUserComponent},
    {path:'multiuserregistration',component:MultiUserRegistrationComponent},
  ]
}
];


// const routes: Routes = [
//   { path: '', redirectTo: 'login', pathMatch: 'full' },
//   { path: 'login', component: LoginComponent },
//   // { path: '', redirectTo: 'login', pathMatch: 'full' },
//   // { path: 'login', component: RegistrationFormComponent },

//   { path: 'register', redirectTo: 'register', pathMatch: 'full' },
//   {path:'register',component:RegisterComponent,canActivate:[AuthGaurdService]},
//   {
//     path: 'dashboard', component: DashboardComponent,canActivate:[AuthGaurdService],
//     children: [
//       {path:'',redirectTo:'pendingrequest',pathMatch:'full',canActivate:[AuthGaurdService]},
//       {path:'pendingrequest',component:PendingrequestComponent},
//       {path:'viewpending/:id',component:PendingViewMobileComponent},
//       {path:'approvedhc',component:ApprovedHcComponent},
//       {path:'viewapproved/:id',component:ApprovedViewMobileComponent},
//       {path:'staredhc',component:StaredHcComponent},
//       {path:'viewstared/:id',component:StaredViewMobileComponent},
//       {path:'showhidden',component:ShowhiddenHcComponent},
//       {path:'viewhidden/:id',component:ShowhiddenViewMobileComponent},
//       {path:'trashhc',component:TrashHcComponent},
//       {path:'viewtrash/:id',component:TrashViewMobileComponent},
//       {path:'specification',component:SpecificationComponent},
//       {path:'specificationhc/:id',component:SpecificationHcComponent},
//       {path:'viewspec/:mailId/:specId',component:SpecificationViewMobileComponent},
//       {path:'remark',component:RemarkComponent},
//       {path:'remarkhc/:id',component:RemarkHcComponent},
//       {path:'viewremark/:mailId/:remarkId',component:RemarkViewMobileComponent},
//       {path:'subject',component:SubjectComponent},
//       {path:'subjecthc/:id',component:SubjectHcComponent},
//       {path:'viewsubject/:mailId/:subjectId',component:SubjectViewMobileComponent},
//       {path:'updatehc/:id/:compname',component:UpdateHcComponent},
//       {path:'vital',component:VitalComponent},
//       {path:'vitalchart',component:VitalchartComponent},
//       {path:'getotpallapproved',component:GetotpallapprovedComponent},
//       {path:'viewallapproved',component:AllapprovedViewMobileComponent},
//       {path:'blankpage',component:BlankpageComponent},
//       {path:'paymentsuccess',component:PaymentsuccessComponent},
//       {path:'paymentfailure',component:PaymentfailureComponent},
//       {path:'transctionPassword',component:AddTransctionPasswordComponent},
//       {path:'changePassword',component:ChangePasswordComponent},
//       {path:'profile',component:ProfileComponent},
//       {path:'updateprofile/:id',component:UpdateprofileComponent},
//       {path:'sharehealthcard',component:SharehealthcardComponent},
//       {path:'sentemail',component:SendemailComponent},
//       {path:'viewsentemail/:id',component:SendemailViewMobileComponent},
//     ]},
// {
//   path: 'doctordashboard', component:DoctordashbordComponent,
//   children: [
//     {path:'',redirectTo:'doctorpage',pathMatch:'full'},
//     {path:'doctorpage',component:DoctorpageComponent,canActivate:[AuthGaurdService]}
//   ]
// }
// ];


@NgModule({
  // imports: [RouterModule.forRoot(routes,)],
  imports: [RouterModule.forRoot(routes,{enableTracing: true, useHash:true,onSameUrlNavigation: 'reload' })],//{onSameUrlNavigation: 'reload'} ,{ useHash: false }
  exports: [RouterModule]
})
export class AppRoutingModule { }
